export const manifest = (() => {
function __memo(fn) {
	let value;
	return () => value ??= (value = fn());
}

return {
	appDir: "_app",
	appPath: "_app",
	assets: new Set(["172KCessna.webp","172SCessna.webp","accelerated_career.webp","accelerated_instrument.webp","accelerated_private.webp","accelerated_sport.webp","aj.webp","boy.webp","cessna_rotate.webp","Cherokee140Piper.webp","clouds_blue_sky_hero.webp","dog_and_plane.webp","eaglet_holdshort.webp","eaglet_runway.webp","eb.webp","events.json","explaining.webp","favicon.ico","FLAP - OFA SEVIS Application Form.docx","flying_look_at_camera.webp","fridge_magnet.png","g2g.webp","ground_effect.webp","hero_image_2.webp","icon_plane_flying_across_screen.svg","instructors.webp","instructor_ingress.webp","instrument_checkride.webp","landing_mid.webp","landscape4.webp","learning.webp","lets_go.webp","logo_name.png","manifest.json","maverick_teaching.webp","multi_achieved.webp","multi_cockpit.webp","multi_engine.webp","multi_instruments.webp","multi_landing.webp","multi_peace.webp","multi_rollout.webp","multi_taxi.webp","neo.webp","P2006tTecnam.webp","P92Eaglet.webp","Pilot100iPiper.webp","postal.png","postal_plane.png","ramp.webp","ready_to_go.webp","replay.html","robots.txt","rob_checkride.webp","sticker.webp","student_with_certificate.webp","sump.webp","sunset.webp","svg/pilot_plane.svelte","svg/send.svg","takeoff.webp","taxi.webp","the_worldo.png","thumbs_up.webp","wings.webp","wing_shot.webp","wing_tip_cloud.webp","service-worker.js"]),
	mimeTypes: {".webp":"image/webp",".json":"application/json",".png":"image/png",".svg":"image/svg+xml",".html":"text/html",".txt":"text/plain"},
	_: {
		client: {"start":"_app/immutable/entry/start.685a57a0.js","app":"_app/immutable/entry/app.53f98318.js","imports":["_app/immutable/entry/start.685a57a0.js","_app/immutable/chunks/scheduler.5b890119.js","_app/immutable/chunks/singletons.f215563a.js","_app/immutable/chunks/index.852d6942.js","_app/immutable/chunks/parse.bee59afc.js","_app/immutable/chunks/control.f5b05b5f.js","_app/immutable/entry/app.53f98318.js","_app/immutable/chunks/scheduler.5b890119.js","_app/immutable/chunks/index.1673eb25.js"],"stylesheets":[],"fonts":[]},
		nodes: [
			__memo(() => import('./nodes/0.js')),
			__memo(() => import('./nodes/1.js')),
			__memo(() => import('./nodes/2.js')),
			__memo(() => import('./nodes/3.js')),
			__memo(() => import('./nodes/4.js')),
			__memo(() => import('./nodes/5.js')),
			__memo(() => import('./nodes/6.js')),
			__memo(() => import('./nodes/7.js')),
			__memo(() => import('./nodes/8.js')),
			__memo(() => import('./nodes/9.js')),
			__memo(() => import('./nodes/10.js')),
			__memo(() => import('./nodes/11.js')),
			__memo(() => import('./nodes/12.js')),
			__memo(() => import('./nodes/13.js')),
			__memo(() => import('./nodes/14.js')),
			__memo(() => import('./nodes/15.js')),
			__memo(() => import('./nodes/16.js')),
			__memo(() => import('./nodes/17.js')),
			__memo(() => import('./nodes/18.js'))
		],
		routes: [
			{
				id: "/",
				pattern: /^\/$/,
				params: [],
				page: { layouts: [0,], errors: [1,], leaf: 3 },
				endpoint: null
			},
			{
				id: "/about-us",
				pattern: /^\/about-us\/?$/,
				params: [],
				page: { layouts: [0,], errors: [1,], leaf: 4 },
				endpoint: null
			},
			{
				id: "/api/store-events",
				pattern: /^\/api\/store-events\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/store-events/_server.ts.js'))
			},
			{
				id: "/blog",
				pattern: /^\/blog\/?$/,
				params: [],
				page: { layouts: [0,], errors: [1,], leaf: 5 },
				endpoint: null
			},
			{
				id: "/blog/[slug]",
				pattern: /^\/blog\/([^/]+?)\/?$/,
				params: [{"name":"slug","optional":false,"rest":false,"chained":false}],
				page: { layouts: [0,], errors: [1,], leaf: 6 },
				endpoint: null
			},
			{
				id: "/contact-us",
				pattern: /^\/contact-us\/?$/,
				params: [],
				page: { layouts: [0,], errors: [1,], leaf: 7 },
				endpoint: null
			},
			{
				id: "/financing",
				pattern: /^\/financing\/?$/,
				params: [],
				page: { layouts: [0,], errors: [1,], leaf: 8 },
				endpoint: null
			},
			{
				id: "/rss.xml",
				pattern: /^\/rss\.xml\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/rss.xml/_server.ts.js'))
			},
			{
				id: "/services/accelerated-training",
				pattern: /^\/services\/accelerated-training\/?$/,
				params: [],
				page: { layouts: [0,2,], errors: [1,,], leaf: 9 },
				endpoint: null
			},
			{
				id: "/services/commercial-pilot",
				pattern: /^\/services\/commercial-pilot\/?$/,
				params: [],
				page: { layouts: [0,2,], errors: [1,,], leaf: 10 },
				endpoint: null
			},
			{
				id: "/services/dgca-india",
				pattern: /^\/services\/dgca-india\/?$/,
				params: [],
				page: { layouts: [0,], errors: [1,], leaf: 11 },
				endpoint: null
			},
			{
				id: "/services/flight-instructor",
				pattern: /^\/services\/flight-instructor\/?$/,
				params: [],
				page: { layouts: [0,2,], errors: [1,,], leaf: 12 },
				endpoint: null
			},
			{
				id: "/services/instrument-rating",
				pattern: /^\/services\/instrument-rating\/?$/,
				params: [],
				page: { layouts: [0,2,], errors: [1,,], leaf: 13 },
				endpoint: null
			},
			{
				id: "/services/international-students",
				pattern: /^\/services\/international-students\/?$/,
				params: [],
				page: { layouts: [0,2,], errors: [1,,], leaf: 14 },
				endpoint: null
			},
			{
				id: "/services/multi-engine-rating",
				pattern: /^\/services\/multi-engine-rating\/?$/,
				params: [],
				page: { layouts: [0,2,], errors: [1,,], leaf: 15 },
				endpoint: null
			},
			{
				id: "/services/private-pilot",
				pattern: /^\/services\/private-pilot\/?$/,
				params: [],
				page: { layouts: [0,2,], errors: [1,,], leaf: 16 },
				endpoint: null
			},
			{
				id: "/services/professional-pilot-program",
				pattern: /^\/services\/professional-pilot-program\/?$/,
				params: [],
				page: { layouts: [0,2,], errors: [1,,], leaf: 17 },
				endpoint: null
			},
			{
				id: "/services/sport-pilot",
				pattern: /^\/services\/sport-pilot\/?$/,
				params: [],
				page: { layouts: [0,2,], errors: [1,,], leaf: 18 },
				endpoint: null
			},
			{
				id: "/sitemap.xml",
				pattern: /^\/sitemap\.xml\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/sitemap.xml/_server.ts.js'))
			}
		],
		matchers: async () => {
			
			return {  };
		}
	}
}
})();

export const prerendered = new Set([]);
